import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';

import { PAGE_NAMES, MISCELLANEOUS_RESOURCES } from 'constant';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { URL, COMPONENT, CONFISCATION_RESOURCES } from './helper';
import SelectConfiscationHome from './SelectConfiscationHome';

const Dashboard: React.FC<{}> = () => {
	return (
		<>
			<Switch>
				<AuthorizedRouteV2
					exact
					configPageName={PAGE_NAMES.miscellaneous}
					path={`/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.confiscationAndRefund}/selectConfiscation`}
					component={SelectConfiscationHome}
				/>
				{_map(_values(CONFISCATION_RESOURCES), (resourceName: string) => (
					<AuthorizedRouteV2
						// key={resourceName}
						configPageName={MISCELLANEOUS_RESOURCES.confiscationAndRefund}
						configResourceName={resourceName}
						path={URL[resourceName]}
						component={COMPONENT[resourceName]}
					/>
				))}
				<Redirect to={`/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.confiscationAndRefund}/selectConfiscation`} />
			</Switch>
		</>
	);
};

export default Dashboard;
